import privateRoutes from "src/routes/private-routes";
import { BIG_FLIP_HELP_CENTER } from "./links";

export const RBAC_KEY = {
  ACCEPT_PAYMENT_CONFIGURATION: "ap_configuration",
  // TODO: need to check if there's RBAC key to this page
  // we'll just add this for now
  ACCEPT_PAYMENT_FLIP_CHECKOUT_PAGE: "ap_configuration_hpp",
  ACCEPT_PAYMENT_PREVIEW: "ap_preview",
  ACCEPT_PAYMENT_HISTORY: "ap_history",
  ACCEPT_PAYMENT_REFUND_HISTORY: "ap_refund_history",
  ACCEPT_PAYMENT_NEW: "ap_new",
  ACCEPT_PAYMENT_REPORT: "ap_report",
  ACCEPT_PAYMENT_SETTLEMENT_REPORT: "ap_settlement_report",
  APPROVAL: "approval",
  APPROVAL_DEPOSIT: "approval_deposit",
  APPROVAL_RECEIPT: "approval_receipt",
  APPROVAL_REVIEW: "approval_review",
  APPROVAL_SUMMARY: "approval_summary",
  BENEFICIARY_LIST: "beneficiary_list",
  BENEFICIARY_REVIEW: "beneficiary_review",
  BENEFICIARY_UPLOAD: "beneficiary_upload",
  DEPOSIT: "deposit",
  DEPOSIT_HISTORY: "deposit_history",
  DEPOSIT_STATEMENT: "deposit_statement",
  DEPOSIT_TOPUP: "deposit_topup",
  DEPOSIT_TOPUP_PAYMENT: "deposit_topup_payment",
  DOCUMENT: "document",
  HELP_CENTER: "help_center",
  HOME: "home",
  // "Persetujuan Transaksi" (.plans/feature_maker-approver-itr_plan.md). Naming mirrors the
  // domestic approval scene's `mt_approval`/`mt_approval_detail` exactly.
  INTERNATIONAL_TRANSFER_APPROVAL: "it_approval",
  INTERNATIONAL_TRANSFER_APPROVAL_DETAIL: "it_approval_detail",
  INTERNATIONAL_TRANSFER_APPROVAL_PAYMENT: "it_approval_payment",
  INTERNATIONAL_TRANSFER_DEPOSIT_PAYMENT: "it_deposit_payment",
  INTERNATIONAL_TRANSFER_HISTORY: "it_history",
  INTERNATIONAL_TRANSFER_HISTORY_DETAIL: "it_history_detail",
  INTERNATIONAL_TRANSFER_MULTI_INPUT: "it_multi_nput",
  INTERNATIONAL_TRANSFER_NEW_TRX: "it_new_trx",
  INTERNATIONAL_TRANSFER_RECEIPT_CSV: "it_receipt_csv",
  INTERNATIONAL_TRANSFER_REPORT: "it_report",
  INTERNATIONAL_TRANSFER_REVIEW: "it_review",
  INTERNATIONAL_TRANSFER_SUMMARY: "it_summary",
  INTERNATIONAL_TRANSFER_UPLOAD_EXCEL: "it_upload_excel",
  MONEY_TRANSFER_BENEFICIARY_LIST: "mt_beneficiary_list",
  MONEY_TRANSFER_HISTORY: "mt_history",
  MONEY_TRANSFER_BUNDLE_HISTORY: "mt_bundle_history",
  MONEY_TRANSFER_APPROVAL: "mt_approval",
  MONEY_TRANSFER_HISTORY_DETAIL: "mt_history_detail",
  MONEY_TRANSFER_APPROVAL_DETAIL: "mt_approval_detail",
  MONEY_TRANSFER_NEW_TRX: "mt_new_trx",
  MONEY_TRANSFER_MULTI_INPUT: "mt_multi_input",
  MONEY_TRANSFER_MULTI_BENEFICIARY: "mt_multi_beneficiary",
  MONEY_TRANSFER_REPORT: "mt_report",
  MONEY_TRANSFER_REVIEW_CSV: "mt_review_csv",
  MONEY_TRANSFER_SUMMARY_CSV: "mt_summary_csv",
  MONEY_TRANSFER_TRANSFER_DEPOSIT: "mt_transfer_deposit",
  MONEY_TRANSFER_TRANSFER_RECEIPT_CSV: "mt_transfer_receipt_csv",
  MONEY_TRANSFER_PROCESS_MAKER: "mt_process_maker",
  MONEY_TRANSFER_UPLOAD_BENEFICIARY_CSV: "mt_upload_beneficiary_csv",
  MONEY_TRANSFER_UPLOAD_SUPER_CSV: "mt_upload_super_csv",
  REFUND_CREATE: "refund_create",
  REFUND_HISTORY: "refund_history",
  SANDBOX_OVERVIEW: "sandbox",
  SANDBOX_MT_NEW_TRX: "sandbox_mt_new_trx",
  SANDBOX_MT_HISTORY: "sandbox_mt_history",
  SANDBOX_IT_HISTORY: "sandbox_it_history",
  SANDBOX_API_SETTING: "sandbox_api_setting",
  SANDBOX_SNAP_CREDENTIAL: "sandbox_snap_credential",
  SANDBOX_ACCOUNT_INQUIRY_HISTORY: "sandbox_account_inquiry_history",
  SANDBOX_ACCEPT_PAYMENT: "sandbox_ap",
  SANDBOX_ACCEPT_PAYMENT_HISTORY: "sandbox_ap_history",
  SANDBOX_ACCEPT_PAYMENT_SIMULATION: "sandbox_ap_simulation",
  SANDBOX_VERIFICATION_HISTORY: "sandbox_verification_history",
  SETTINGS_API: "settings_api",
  SETTINGS_CREDENTIAL: "settings_credential",
  SETTINGS_NOTIFICATION: "settings_notification",
  SETTINGS_PROFILE: "settings_profile",
  SETTINGS_TFA: "settings_tfa",
  SETTINGS_TFA_NEW: "settings_tfa_new",
  SETTINGS_TRANSACTION: "settings_transaction",
  SETTINGS_DEPOSIT: "settings_deposit",
  SETTINGS_ACTIVITY_LOG: "settings_activity_log",
  USER_MANAGEMENT: "user_management"
};

export const RBAC_ID = {
  [RBAC_KEY.ACCEPT_PAYMENT_CONFIGURATION]: privateRoutes.acceptPaymentConfiguration.path,
  [RBAC_KEY.ACCEPT_PAYMENT_FLIP_CHECKOUT_PAGE]: privateRoutes.acceptPaymentFlipCheckoutPage.path,
  [RBAC_KEY.ACCEPT_PAYMENT_HISTORY]: privateRoutes.acceptPaymentHistory.path,
  [RBAC_KEY.ACCEPT_PAYMENT_REFUND_HISTORY]: privateRoutes.acceptPaymentRefundHistory.path,
  [RBAC_KEY.ACCEPT_PAYMENT_NEW]: privateRoutes.acceptPayment.path,
  [RBAC_KEY.ACCEPT_PAYMENT_REPORT]: privateRoutes.acceptPaymentReport.path,
  [RBAC_KEY.ACCEPT_PAYMENT_SETTLEMENT_REPORT]: privateRoutes.acceptPaymentSettlementReport.path,
  [RBAC_KEY.ACCEPT_PAYMENT_PREVIEW]: privateRoutes.acceptPaymentLinkPreview.path,
  [RBAC_KEY.APPROVAL]: privateRoutes.approval.path,
  [RBAC_KEY.APPROVAL_DEPOSIT]: privateRoutes.approvalDeposit.path,
  [RBAC_KEY.APPROVAL_RECEIPT]: privateRoutes.approvalReceipt.path,
  [RBAC_KEY.APPROVAL_REVIEW]: privateRoutes.approvalReview.path,
  [RBAC_KEY.APPROVAL_SUMMARY]: privateRoutes.approvalSummary.path,
  [RBAC_KEY.BENEFICIARY_LIST]: privateRoutes.beneficiaryList.path,
  [RBAC_KEY.BENEFICIARY_REVIEW]: privateRoutes.beneficiaryReview.path,
  [RBAC_KEY.BENEFICIARY_UPLOAD]: privateRoutes.beneficiaryUpload.path,
  [RBAC_KEY.DEPOSIT]: privateRoutes.deposit.path,
  [RBAC_KEY.DEPOSIT_HISTORY]: privateRoutes.depositHistory.path,
  [RBAC_KEY.DEPOSIT_STATEMENT]: privateRoutes.depositStatement.path,
  [RBAC_KEY.DEPOSIT_TOPUP]: privateRoutes.depositTopUp.path,
  [RBAC_KEY.DEPOSIT_TOPUP_PAYMENT]: privateRoutes.depositTopUpPayment.path,
  [RBAC_KEY.DOCUMENT]: privateRoutes.document.path,
  [RBAC_KEY.HELP_CENTER]: BIG_FLIP_HELP_CENTER,
  [RBAC_KEY.HOME]: privateRoutes.home.path,
  [RBAC_KEY.INTERNATIONAL_TRANSFER_APPROVAL]: privateRoutes.internationalTransactionApproval.path,
  [RBAC_KEY.INTERNATIONAL_TRANSFER_APPROVAL_DETAIL]: privateRoutes.internationalTransactionApprovalReview.path,
  [RBAC_KEY.INTERNATIONAL_TRANSFER_APPROVAL_PAYMENT]: privateRoutes.internationalTransactionApprovalPayment.path,
  [RBAC_KEY.INTERNATIONAL_TRANSFER_DEPOSIT_PAYMENT]: privateRoutes.internationalDepositPayment.path,
  [RBAC_KEY.INTERNATIONAL_TRANSFER_HISTORY]: privateRoutes.historyInternationalTransaction.path,
  [RBAC_KEY.INTERNATIONAL_TRANSFER_HISTORY_DETAIL]: privateRoutes.historyInternationalTransactionDetail.path,
  [RBAC_KEY.INTERNATIONAL_TRANSFER_MULTI_INPUT]: privateRoutes.internationalTransactionMultiInput.path,
  [RBAC_KEY.INTERNATIONAL_TRANSFER_NEW_TRX]: privateRoutes.internationalTransaction.path,
  [RBAC_KEY.INTERNATIONAL_TRANSFER_RECEIPT_CSV]: privateRoutes.internationalTransferReceiptCsv.path,
  [RBAC_KEY.INTERNATIONAL_TRANSFER_REPORT]: privateRoutes.historyInternationalTransactionReport.path,
  [RBAC_KEY.INTERNATIONAL_TRANSFER_REVIEW]: privateRoutes.internationalTransactionReview.path,
  [RBAC_KEY.INTERNATIONAL_TRANSFER_SUMMARY]: privateRoutes.internationalTransactionSummary.path,
  [RBAC_KEY.INTERNATIONAL_TRANSFER_UPLOAD_EXCEL]: privateRoutes.internationalTransactionUploadExcel.path,
  [RBAC_KEY.MONEY_TRANSFER_BENEFICIARY_LIST]: privateRoutes.transactionBeneficiaryList.path,
  [RBAC_KEY.MONEY_TRANSFER_HISTORY]: privateRoutes.historyTransaction.path,
  [RBAC_KEY.MONEY_TRANSFER_BUNDLE_HISTORY]: privateRoutes.historyMultiTransaction.path,
  [RBAC_KEY.MONEY_TRANSFER_APPROVAL]: privateRoutes.historyWaitingApproval.path,
  [RBAC_KEY.MONEY_TRANSFER_HISTORY_DETAIL]: privateRoutes.historyTransactionDetail.path,
  [RBAC_KEY.MONEY_TRANSFER_APPROVAL_DETAIL]: privateRoutes.historyTransactionDraftDetail.path,
  [RBAC_KEY.MONEY_TRANSFER_NEW_TRX]: privateRoutes.transaction.path,
  [RBAC_KEY.MONEY_TRANSFER_MULTI_INPUT]: privateRoutes.transactionMultiInput.path,
  [RBAC_KEY.MONEY_TRANSFER_MULTI_BENEFICIARY]: privateRoutes.transactionMultiBeneficiary.path,
  [RBAC_KEY.MONEY_TRANSFER_REPORT]: privateRoutes.historyTransactionReport.path,
  [RBAC_KEY.MONEY_TRANSFER_REVIEW_CSV]: privateRoutes.transactionReviewCsv.path,
  [RBAC_KEY.MONEY_TRANSFER_SUMMARY_CSV]: privateRoutes.transactionSummaryCsv.path,
  [RBAC_KEY.MONEY_TRANSFER_TRANSFER_DEPOSIT]: privateRoutes.transactionTransferDeposit.path,
  [RBAC_KEY.MONEY_TRANSFER_TRANSFER_RECEIPT_CSV]: privateRoutes.transactionTransferReceiptCsv.path,
  [RBAC_KEY.MONEY_TRANSFER_PROCESS_MAKER]: privateRoutes.transactionProcessMaker.path,
  [RBAC_KEY.MONEY_TRANSFER_UPLOAD_BENEFICIARY_CSV]: privateRoutes.transactionUploadBeneficiaryCsv.path,
  [RBAC_KEY.MONEY_TRANSFER_UPLOAD_SUPER_CSV]: privateRoutes.transactionUploadSuperCsv.path,
  [RBAC_KEY.REFUND_CREATE]: privateRoutes.createRefund.path,
  [RBAC_KEY.REFUND_HISTORY]: privateRoutes.refund.path,
  [RBAC_KEY.SANDBOX_ACCEPT_PAYMENT]: privateRoutes.sandboxAcceptPaymentOverview.path,
  [RBAC_KEY.SANDBOX_ACCEPT_PAYMENT_HISTORY]: privateRoutes.sandboxAcceptPaymentHistory.path,
  [RBAC_KEY.SANDBOX_ACCOUNT_INQUIRY_HISTORY]: privateRoutes.sandboxAccountInquiryHistory.path,
  [RBAC_KEY.SANDBOX_API_SETTING]: privateRoutes.sandboxApiSettings.path,
  [RBAC_KEY.SANDBOX_IT_HISTORY]: privateRoutes.sandboxInternationalTransactionHistory.path,
  [RBAC_KEY.SANDBOX_MT_HISTORY]: privateRoutes.sandboxTransactionHistory.path,
  [RBAC_KEY.SANDBOX_MT_NEW_TRX]: privateRoutes.sandboxTransaction.path,
  [RBAC_KEY.SANDBOX_OVERVIEW]: privateRoutes.sandboxOverview.path,
  [RBAC_KEY.SANDBOX_SNAP_CREDENTIAL]: privateRoutes.sandboxSnapCredentials.path,
  [RBAC_KEY.SANDBOX_VERIFICATION_HISTORY]: privateRoutes.sandboxVerificationHistory.path,
  [RBAC_KEY.SETTINGS_API]: privateRoutes.settingsApiSetting.path,
  [RBAC_KEY.SETTINGS_CREDENTIAL]: privateRoutes.settingsCredentials.path,
  [RBAC_KEY.SETTINGS_NOTIFICATION]: privateRoutes.settingsNotification.path,
  [RBAC_KEY.SETTINGS_PROFILE]: privateRoutes.settingsProfileAccount.path,
  [RBAC_KEY.SETTINGS_TFA]: privateRoutes.settingsTwoFactorAuth.path,
  [RBAC_KEY.SETTINGS_TFA_NEW]: privateRoutes.settingsTFA.path,
  [RBAC_KEY.SETTINGS_TRANSACTION]: privateRoutes.settingsTransaction.path,
  [RBAC_KEY.SETTINGS_DEPOSIT]: privateRoutes.settingsDeposit.path,
  [RBAC_KEY.SETTINGS_ACTIVITY_LOG]: privateRoutes.settingsActivityLog.path,
  [RBAC_KEY.USER_MANAGEMENT]: privateRoutes.userManagement.path
};
